import { render, staticRenderFns } from "./orderWxshenpi.vue?vue&type=template&id=2df881ba&scoped=true"
import script from "./orderWxshenpi.vue?vue&type=script&lang=js"
export * from "./orderWxshenpi.vue?vue&type=script&lang=js"
import style0 from "./orderWxshenpi.vue?vue&type=style&index=0&id=2df881ba&prod&scoped=true&lang=css"
import style1 from "./orderWxshenpi.vue?vue&type=style&index=1&id=2df881ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df881ba",
  null
  
)

export default component.exports